import AppConstant from "../assets/js/AppConstant";
import { UserType } from "../assets/js/AppUserProfile";

const terminateStandAloneContent = {
  Dealer: {
    text: "ตั้งแต่วันที่ 15 ตุลาคม ระบบ Marketing Claim Activity จะย้ายไปใช้งานผ่าน RDOP Portal กรุณาเข้าสู่ระบบผ่าน",
    link: AppConstant.RDOP_URL,
  },
  Rever: {
    text: "ตั้งแต่วันที่ 15 ตุลาคม ระบบ Marketing Claim Activity จะย้ายไปใช้งานผ่าน RMOS Portal กรุณาเข้าสู่ระบบผ่าน",
    link: AppConstant.RMOS_URL,
  },
};

export const annoucements = {
  documentDueDate: {
    displayTexts: [
      "ปิดรับการขออนุมัติและนำส่งเอกสารเบิกงบสนับสนุนกิจกรรมส่งเสริมการขาย ในไตรมาสที่ 1 ของปี 2568 เนื่องจากครบกำหนดการรับเอกสารแล้ว",
      "ปิดรับการขออนุมัติและนำส่งเอกสารเบิกงบสนับสนุนกิจกรรมส่งเสริมการขาย ในไตรมาสที่ 2 ของปี 2568 เนื่องจากครบกำหนดการรับเอกสารแล้ว",
      "ระยะเวลาของกิจกรรมระหว่างวันที่ 1 กรกฏาคม 2568 - 30 กันยายน 2568 ระบบจะปิดการรับเอกสารวันที่ 31 ตุลาคม 2568",
    ],
    detailsTexts: [
      "ปิดรับการขออนุมัติและนำส่งเอกสารเบิกงบสนับสนุนกิจกรรมส่งเสริมการขายในไตรมาสที่ 1 ของปี 2568 เนื่องจากครบกำหนดการรับเอกสารแล้ว",
      "ปิดรับการขออนุมัติและนำส่งเอกสารเบิกงบสนับสนุนกิจกรรมส่งเสริมการขาย ในไตรมาสที่ 2 ของปี 2568 เนื่องจากครบกำหนดการรับเอกสารแล้ว",
      "ระยะเวลาของกิจกรรมระหว่างวันที่ 1 กรกฏาคม 2568 - 30 กันยายน 2568 ระบบจะปิดการรับเอกสารวันที่ 31 ตุลาคม 2568",
    ],
  },
  terminateStandAlone: {
    [UserType.DEALER_BYD]: terminateStandAloneContent.Dealer,
    [UserType.DEALER_DENZA]: terminateStandAloneContent.Dealer,
    [UserType.REVER]: terminateStandAloneContent.Rever,
    [UserType.ADMIN]: terminateStandAloneContent.Rever,
    [UserType.ACCOUNTANT]: terminateStandAloneContent.Rever,
    [UserType.BUSINESS_CONTROL]: terminateStandAloneContent.Rever,
  },
};
